import { type Dispatch, type SetStateAction } from "react";
import clsx from "clsx";
import styles from "./TableLabels.module.scss";
import { Checkbox } from "@/frontend/shared/ui/Checkbox";
import SortControl from "../../SortControl/SortControl";
import { Typography } from "@/frontend/shared/ui/Typography/Typography";
import { headers } from "../const/const";
import { TActiveSort, TSortDirection } from "../../../model/types/types";

type TTableLabels = {
  className?: string;
  onChange?: () => void;
  value?: boolean;
  isFounder?: boolean;
  activeSort: TActiveSort;
  setActiveSort: Dispatch<SetStateAction<TActiveSort>>;
};

export function TableLabels({ className, onChange, value, isFounder, activeSort, setActiveSort }: TTableLabels) {
  const getDirectionForColumn = (column: TActiveSort["column"]) => {
    return activeSort.column === column ? activeSort.direction : null;
  };

  const handleNameChange = (direction: TSortDirection) => {
    setActiveSort({
      column: direction ? "name" : null,
      direction
    });
  };

  const handleTotalFundingChange = (direction: TSortDirection) => {
    setActiveSort({
      column: direction ? "totalFunding" : null,
      direction
    });
  };

  const handleFinancialStageChange = (direction: TSortDirection) => {
    setActiveSort({
      column: direction ? "financialStage" : null,
      direction
    });
  };

  const handleFoundingYearChange = (direction: TSortDirection) => {
    setActiveSort({
      column: direction ? "foundingYear" : null,
      direction
    });
  };

  return (
    <div className={styles.stickyContainer}>
      <div className={clsx(styles.container, className, isFounder && styles.isFounderContainer)}>
        {!isFounder && (
          <Checkbox onChange={() => onChange?.()} value={value || false} className={styles.checkbox} isTableLabel />
        )}
        {headers.map((item, index) => (
          <div key={index} className={clsx(item.key === "name" ? styles.checkboxContainer : styles.labelContainer)}>
            <Typography className={clsx(styles.label)} variant={"label-4"} color={"greyscale600"}>
              {item.label}
            </Typography>

            {item.key === "name" ? (
              <SortControl
                direction={getDirectionForColumn("name")}
                onChange={handleNameChange}
                id="discoverPage-companyNameSort"
              />
            ) : null}

            {item.key === "totalFunding" ? (
              <SortControl
                direction={getDirectionForColumn("totalFunding")}
                onChange={handleTotalFundingChange}
                id="discoverPage-totalFundingSort"
              />
            ) : null}

            {item.key === "financialStage" ? (
              <SortControl
                direction={getDirectionForColumn("financialStage")}
                onChange={handleFinancialStageChange}
                id="discoverPage-financialStageSort"
              />
            ) : null}

            {item.key === "foundingDate" ? (
              <SortControl
                direction={getDirectionForColumn("foundingYear")}
                onChange={handleFoundingYearChange}
                id="discoverPage-foundingDateSort"
              />
            ) : null}

            {/* {index === 0 && <CaretUpDownIcon className={styles.caretUpDownIcon} />} */}
          </div>
        ))}
      </div>
    </div>
  );
}
